<template>
  <div id="app">
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="router-view">
      </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="router-view"></router-view> -->
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">
//去掉滚动条
::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
</style>
